import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const IESplashPage = React.lazy(() => import("./IESplashPage"));

function IESplashPageWrapper(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "pages.unsupportedBrowserPage.pageTitle",
      defaultValue: "Smart Portal - Unsupported Browser",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "common.loading", defaultValue: "loading" })}
        />
      }
    >
      <IESplashPage {...props} />
    </Suspense>
  );
}

export default IESplashPageWrapper;
